function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}import styles from './snow-view-stats.scss';
import template from './snow-view-stats.html';

export var SnowViewStatsComponent = {
  template: template,
  styles: styles,
  bindings: {
    viewTitle: "@",
    viewValue: "@",
    unit: "@",
    onUpdate: "&",
    textButton: "@",
    hideButton: "<",
    fontSize: "@" },

  controller:
  function SnowViewStatsComponentController() {
    "ngInject";_classCallCheck(this, SnowViewStatsComponentController);
    console.log(this);
  } };